import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Estado de una solicitud de ampliación de techo, con el MISMO aspecto en el
// portal partner y en la bandeja del admin: si cada lado lo pintara distinto,
// una conversación sobre «tu solicitud está X» acabaría en confusión.
// Un estado desconocido (backend más nuevo que este portal) se pinta tal cual
// en vez de desaparecer.

const LimitRequestStatusChip: React.FC<{ status: string; size?: 'small' | 'medium' }> = ({
  status,
  size = 'small'
}) => {
  const { t } = useTranslation();
  const map: Record<string, { color: 'default' | 'warning' | 'success' | 'error'; label: string }> = {
    pending: { color: 'warning', label: t('limitRequests.status.pending', 'Pendiente') },
    approved: { color: 'success', label: t('limitRequests.status.approved', 'Aprobada') },
    rejected: { color: 'error', label: t('limitRequests.status.rejected', 'Rechazada') },
    cancelled: { color: 'default', label: t('limitRequests.status.cancelled', 'Retirada') }
  };
  const entry = map[status] ?? { color: 'default' as const, label: status };
  return <Chip size={size} variant="outlined" color={entry.color} label={entry.label} />;
};

export default LimitRequestStatusChip;
